//IE Polyfill for support for 'forEach'
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    var i;
    thisArg = thisArg || window;
    for (i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
gsap.config({ nullTargetWarn: false });
gsap.registerPlugin(ScrollTrigger);
MorphSVGPlugin.convertToPath("polygon");
let tlVshape = gsap.timeline();
tlVshape
  .to("#big-one", {
    morphSVG: {
      shape: "#big",
      duration: 2,
      autoAlpha: 1,
      ease: "power0.out",
    },
  })
  .to(
    "#small-one",
    {
      morphSVG: {
        shape: "#small",
        shapeIndex: 0,
        autoAlpha: 1,
        ease: "power0.out",
      },
    },
    "-=1.2"
  )
  .to("#middle-one", {
    morphSVG: {
      shape: "#middle",
      duration: 1.5,
      autoAlpha: 1,
      ease: "power0.out",
    },
  });

let intitalContent = gsap.timeline();
intitalContent
  /*.set("header, footer", {
    autoAlpha: 1,
    ease: "power2.out",
  })*/
  .to("img", {
    autoAlpha: 1,
    duration: 1.5,
    ease: "power2.out",
  })
  /*.fromTo(
    ".trigger-reveal",
    {
      opacity: 0,
      y: 30,
    },
    {
      autoAlpha: 1,
      y: 0,
      duration: 1.5,
      ease: "power2.out",
    },
    "-=1.8"
  )
  .to(
    ".reveal-first",
    1.2,
    {
      borderWidth: 0,
      autoRound: false,
      ease: "power1.out",
      zIndex: "-2",
    },
    "-=1.5"
  )*/
  .add(tlVshape, "-=1");

/*const revealContentElements = document.querySelectorAll(".reveal-content");
revealContentElements.forEach(element => {
  if(element.getBoundingClientRect().top < window.innerHeight) {
    element.classList.remove('reveal-content')
  }
})
gsap.set('.reveal-content', {autoAlpha: 0});

let revealContainers = document.querySelectorAll(".trigger-reveal");
revealContainers.forEach((container) => {
  let content = container.querySelectorAll(".reveal-content");
  let revealContent = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: "top 75%",
      scrub: false,
      // markers: true, //debug
    },
    paused: true
  });
  
  revealContent
    .fromTo(
      content,
      {
        autoAlpha: 0,
        y: 45,
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: 1.5,
        ease: "power2.out",
      },
    )
});*/